<section #sectionRef class="background-background">
  <ngb-alert [dismissible]="false" *ngIf="!enabledResources" type="warning" class="text-center m-3">
    To proceed with Floorplan setup, please enable the Resources feature.
  </ngb-alert>

  <div class="alert-absolute background-background" *ngIf="!isOnBusinessPlan">
    <ngb-alert [dismissible]="false" class="text-center w-100 mt-3">
      The features on this page are not available on the {{ plansAlertData.notAvailableForPlan }}.
      <a routerLink="/settings/location/billing" class="alert-link" [innerText]="plansAlertData.linkText"></a>
      {{ plansAlertData.afterLinkText }}
    </ngb-alert>
  </div>

  <div class="fullscreen-cover">
    <div class="add-floor-plan-text w-100 h-100" *ngIf="floorPlansCount === 0 && !isFloorPlansLoading">
      <div class="d-flex flex-row justify-content-center align-items-center h-100">
        <h1>Please <a (click)="addFloorPlan()" [class.disabled]="!enabledResources || !isOnBusinessPlan">Add your first Floorplan</a></h1>
      </div>
    </div>

    <div class="wrapper" [class.invisible]="!enabledResources || (floorPlansCount === 0 && !isFloorPlansLoading)">
      <div class="d-flex justify-content-between flex-row align-items-start h-100">
        <div class="canvas-wrapper">
          <frontend-canvas
            #graphCanvas
            [canvasId]="'canvas-builder'"
            [leftLayoutOffsetPx]="leftLayoutOffsetPx"
            [class.no-events]="confirmChangesDialogOpen"
            [getItems]="getItems"
            [showFloorsEdit]="true"
            [customMultiSelectEnabled]="true"
            [allowObjectCustomSelection]="true"
            [multiTransformSelectMode]="multiTransformSelectMode"
            [selectedObjectId]="selectedObjectId"
            [resourcesMap]="floorPlanTableService.resourcesMap"
            [transformEnabled]="activeTab === tabValues.tables"
            [floorPlanItems]="floorPlanTableService.floorPlans"
            [canvasAreaHeightPx]="sectionRef.offsetHeight - 12"
            [customSelectMode]="activeTab === tabValues.sections"
            [allowOnlySectionIdSelection]="!allowSectionMultiSelection ? undefined : selectedSectionId"
            [allowCustomSelection]="activeTab === tabValues.sections"
            [isOnFreePlan]="!isOnBusinessPlan"
            (planEdit)="onPlanEdit($event)"
            (objectSelected)="onObjectSelected($event)"
            (floorChanged)="floorChanged($event)"
            (dropNewObject)="dropElement($event)"
            (objectMultiSelected)="sections.canvasTableSelectionChanges($event)"
            (clickedOnCanvas)="onCanvasClicked()"
            (htmlDragStart)="popoutHidden = true"
            (objectDragStart)="isDraggingObject = true"
            (objectDragEnd)="isDraggingObject = false; autoSave($event)"
            (multiTransformSelectModeChange)="onCanvasClicked(); multiTransformSelectMode = $event"
          >
            <div class="d-flex align-items-center">
              <tablesready-floorplan-switcher
                [items]="floorPlanTableService.floorPlans"
                [showEditButton]="graphCanvas.showFloorsEdit"
                [disabled]="!isOnBusinessPlan"
                (floorChange)="graphCanvas.floorPlanId = $event; graphCanvas.onFloorChange($event, 'builder floorplan switcher')"
                (editPlan)="graphCanvas.planEdit.emit($event)"
              ></tablesready-floorplan-switcher>

              <button
                class="btn font-weight-bold btn-outline-info ml-2 background-background multi-btn"
                ngbTooltip="Select multiple tables"
                [disabled]="!isOnBusinessPlan"
                [disableTooltip]="!isOnBusinessPlan"
                (click)="onCanvasClicked(); toggleMultiTransformMode()"
              >
                <tr-icon
                  *ngIf="!multiTransformSelectMode"
                  [icon]="icon.multiSelect"
                  [color]="iconColor.blue"
                  [size]="iconSize.medium"
                ></tr-icon>

                <tr-icon
                  *ngIf="multiTransformSelectMode"
                  [icon]="icon.cancel"
                  [color]="iconColor.blue"
                  [size]="iconSize.medium"
                ></tr-icon>
              </button>
            </div>
          </frontend-canvas>
        </div>

        <div
          class="popout border-border"
          [class.invisible]="isFloorPlansLoading"
          [class.open]=""
          [class.hidden]="popoutHidden || isDraggingObject"
          [style.height]="'100%'"
          [style.min-height]="'100%'"
        >
          <div #popoutContent class="popout-content background-background">
            <div class="content-top" #contentTop>
              <div class="d-flex flex-row justify-content-end align-items-center">
                <button class="btn btn-info" (click)="addFloorPlan()" [disabled]="!isOnBusinessPlan">+ Add floor plan</button>
              </div>

              <tablesready-tabs
                [tabs]="tabs"
                [activeTab]="activeTab"
                [boldText]="true"
                (changeTab)="onChangeTab($event); sections.cancelEdit();"
              ></tablesready-tabs>
            </div>

            <ng-container *ngIf="activeTab === tabValues.tables">
              <div
                class="tab-content"
                *ngIf="!openedAddTableForm && !openedAddObjectForm; else displayForms"
                [style.height]="'calc(' + (popoutContent.offsetHeight - contentTop.offsetHeight) + 'px)'"
              >
                <tablesready-tables (elementDragged)="saveTableData($event)" [disabled]="!isOnBusinessPlan"></tablesready-tables>
                <tablesready-floorplan-objects (elementDragged)="saveTableData($event)" [disabled]="!isOnBusinessPlan"></tablesready-floorplan-objects>
              </div>
            </ng-container>

            <div
              class="tab-content px-0"
              [hidden]="activeTab !== tabValues.sections"
              [style.height]="'calc(' + (popoutContent.offsetHeight - contentTop.offsetHeight) + 'px)'"
            >
              <tablesready-sections
                #sections
                [windowHeight]="contentAreaHeight"
                [resourcesMap]="floorPlanTableService.resourcesMap"
                [sections]="floorPlanTableService.savedSections"
                [tables]="floorPlanTableService.savedTables"
                [onSectionClose]="onSectionClose()"
                [onSectionDelete]="onSectionDelete"
                [contentHeight]="(popoutHidden ? tabsHeight + 40 : 0) + contentTop.offsetHeight"
                [disabled]="!isOnBusinessPlan"
                (editModeChange)="sectionEditModeChange($event)"
                (selectionColorChange)="graphCanvas.setMultiselectColor($event)"
                (tableInputIdsChange)="graphCanvas.selectTablesByIds($event)"
                (selectTable)="fromSectionsToTables($event)"
              ></tablesready-sections>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div
  *ngIf="floorPlansCount > 0"
  slot="fixed"
  class="popout-tip background-background"
  [style.right.px]="popoutHidden || isDraggingObject ? 0 : popoutContent.offsetWidth"
  (click)="popoutHidden = !popoutHidden"
>
  <tr-icon *ngIf="popoutHidden" [icon]="icon.arrowLeft"></tr-icon>
  <tr-icon *ngIf="!popoutHidden" [icon]="icon.arrowRight"></tr-icon>
</div>

<ng-template #displayForms>

  <!--
  viewport height changes on software keyboard appearance and screws up calculations below
  [style.height]="(contentAreaHeight - ((popoutHidden ? tabsHeight + 40 : 0) + contentTop.offsetHeight)) + 'px'"
  -->
  <div class="tab-content">
    <tablesready-add-table-form
      *ngIf="openedAddTableForm"
      [width]="width"
      [height]="height"
      [left]="left"
      [top]="top"
      [size]="selectedSize"
      [shape]="selectedShape"
      [resourceId]="selectedResourceId"
      [sectionId]="selectedObjectSectionId ? selectedObjectSectionId : null"
      [rotation]="rotation"
      [isEditMode]="isObjectEditMode"
      [locationId]="locationId"
      [onCreate]="onTableCreateClose"
      [onSave]="onTableSaveClose"
      [resources]="resources"
      [services]="floorPlanTableService.services"
      [generatedTableName]="generatedTableName"
      [duplicatedTable]="duplicatedTable"
      [onTableDelete]="onObjectDeleteClose"
      [onResourceDelete]="onDeleteResource"
      [onResourceCreate]="onCreateResource"
      [onResourceUpdate]="onUpdateResource"
      [onTableDuplicate]="onTableDuplicate"
      [sections]="floorPlanTableService.savedSections"
      [tableId]="selectedObjectId"
      [floorPlanId]="selectedFloorPlanId"
      (resourceChanged)="resourceChanged($event)"
      (formClosed)="onTableFormClose($event)"
      (tableRemoved)="removeObjectFromCanvas($event)"
      (nameChanged)="changeTableText($event)"
      (capacityChanged)="changeTableText(undefined, $event)"
      (shapeChanged)="changeTableSizeOrShape(this.selectedSize, $event)"
      (sizeChanged)="changeTableSizeOrShape($event, this.selectedShape)"
      (rotationAngleChanged)="changeTableRotation($event)"
      (formTouched)="setTableFormTouched($event)"
    ></tablesready-add-table-form>

    <tablesready-floorplan-add-object-form
      *ngIf="openedAddObjectForm"
      [objectId]="selectedObjectId"
      [name]="objectName"
      [width]="width"
      [height]="height"
      [left]="left"
      [top]="top"
      [shape]="selectedShape"
      [floorPlanId]="selectedFloorPlanId"
      [rotation]="rotation"
      [onCreate]="onObjectAddClose"
      [onSave]="onObjectSaveClose"
      [onDelete]="onObjectDeleteClose"
      [isEditMode]="isObjectEditMode"
      (formClosed)="onObjectFormClosed($event)"
      (nameChange)="changeObjectText($event)"
      (tableRemoved)="removeObjectFromCanvas($event)"
      (rotationChange)="changeTableRotation($event)"
      (formTouched)="setObjectFormTouched($event)"
    ></tablesready-floorplan-add-object-form>
  </div>
</ng-template>
